import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service">
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>1. Acceptance</h3>
      <p>By using TokenGuard, you agree to these terms. If you do not agree, do not use the service.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>2. Usage</h3>
      <p>TokenGuard is provided as-is for monitoring LLM token consumption. We are not responsible for API downtime or data loss at your providers.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>3. Accounts</h3>
      <p>You are responsible for maintaining the security of your account credentials.</p>
      <h3 style={{ fontSize: 17, color: "var(--charcoal)", marginTop: 8 }}>4. Termination</h3>
      <p>We reserve the right to suspend accounts that abuse the service or violate provider terms.</p>
    </LegalPage>
  );
}
